import React, { useMemo } from "react";
import { cn } from "~/lib/cn";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: unknown;
};

export const Input = React.memo(
  React.forwardRef<HTMLInputElement, InputProps>(
    ({ type, className, error, ...props }, ref) => {
      const inputClassName = useMemo(
        () =>
          cn(
            error
              ? "w-full px-3 py-2 rounded-md mb-2 border border-red-700 focus:border-red-700 focus:ring-red-200 focus:ring-2 focus:outline-none transition-colors duration-200 bg-white disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed flex h-10"
              : "input flex h-10",
            className,
          ),
        [error, className],
      );

      return (
        <input type={type} className={inputClassName} ref={ref} {...props} />
      );
    },
  ),
);

Input.displayName = "Input";
